export default __webpack_public_path__ + "static/media/mark-as-read.b7da71e3.svg";